import React from 'react';

const ErrorPage = () => (
  <div className='d-flex justify-content-center align-items-center' style = {{ height :'79vh' }}>
    <div>
    <h1>404 - Page Not Found</h1>
    <p className='text-center'>The page you are looking for does not exist.</p>
  </div>
  </div>
);

export default ErrorPage;
